import React from 'react';
import { translate } from 'admin-on-rest';
import { Card, CardTitle, CardText } from 'material-ui';

const NotFound = ({ translate: t }) => (
  <Card>
    <CardTitle>{t('unauthorizedHeader')}</CardTitle>
    <CardText>{t('unauthorizedText')}</CardText>
  </Card>
);

export default translate(NotFound);
